import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { DealPriorityApiService } from '../services/deal-priority-api.service';
import { DealPriorityResponse } from '../models/deal-priority.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-deal-priority-list',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, PageBreadcrumbComponent, HasPermissionDirective],
  templateUrl: './deal-priority-list.component.html',
})
export class DealPriorityListComponent implements OnInit {
  items: DealPriorityResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private api: DealPriorityApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    const businessId = this.authService.getCurrentUser()?.businessId;
    if (!businessId) {
      this.error = 'No se pudo obtener el negocio del usuario';
      return;
    }

    this.loading = true;
    this.error = '';

    this.api.getAll(businessId).subscribe({
      next: (data) => {
        this.items = data.content;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar las prioridades';
        this.loading = false;
        console.error('Error:', err);
      },
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-deals/prioridades/crear']);
  }

  editar(item: DealPriorityResponse): void {
    this.router.navigate(['/config-deals/prioridades/editar', item.id]);
  }

  async eliminar(item: DealPriorityResponse): Promise<void> {
    const businessId = this.authService.getCurrentUser()?.businessId;
    if (!businessId) return;

    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar prioridad',
      message: `¿Está seguro de eliminar la prioridad "${item.name}"?`,
    });
    if (!ok) return;
    this.api.delete(item.id, businessId).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Prioridad', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.confirmDialog.alert({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar la prioridad',
          variant: 'danger',
        });
        this.toast.error({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar la prioridad',
        });
      },
    });
  }
}
